import { Component } from '@angular/core';
import { environment } from '../../../../common/environment/environment';
import { AdminLoginComponent } from './admin-login.component';
import { DefaultAdminLoginComponent } from './default-admin-login.component';

@Component({
    selector: 'oneclick-login',
    template: `
        <div class="d-flex justify-content-center">
            <admin-login/>
        </div>`,
    imports: [
        'development' === environment.name
            ? AdminLoginComponent
            : DefaultAdminLoginComponent,
    ],
})
export class RootComponent {}
